function stickyHeader() {
  if (document.documentElement.scrollTop > 0) {
    document.querySelector('.header').classList.add('header--sticky');
  } else {
    document.querySelector('.header').classList.remove('header--sticky');
  }
}

$(window).on('scroll', function () {
  stickyHeader();
});
